export const API = 'https://student-teacher-admin-dashboard-app.onrender.com';
